export default {"src":"/_next/static/media/instagram.857a1026.svg","height":22,"width":22};